import axios from "axios";

export const FRANCHISES_URL = "api/franchises";
export const FRANCHISES_URL_LIVE = "franchise";
export const VAN_LIVE = "van";
export const DRIVER_LOADER = "driver-loader";
export const DEPOT_LIST = "depot-franchise";
export const VAN_STATUS = "van-status-update";
export const DEPOT_SEARCH = "depot-franchise-search";
export const DEPOT_SEARCH_SAVE = "depot-franchise-save";
export const DEPOT_STATUS = "depot-franchise-status-update";
export const DRIVERLOADER_STATUS = "driver-loader-status-update";
export const DRIVER_SEARCH_LIST = "driver-loader-list";
export const FRANCHISES_POPOVER = "franchise-details-save";
export const POSTCODE = "postcode";
export const POSTCODE_LIVE = "search-postcode";
export const SECTOR = "sector";
export const SECTOR_STATUS = "sector-status-update";
export const COUNTRY_FRANCHISE = "promotion/country-franchise/list";
export const WORKING_DAYS = "franchise-working-days-list";
export const DELETE = "delete/franchise";
export const EDIT_WORKING_DAYS = "franchise-working-days-save";
export const Auto_Mate = "automated-price";
export const CREATE_SITE = "franchise-site/site";
export const SITE_LIST = "franchise-site/site";
export const CLASS_LIST = "franchise-site-class/site-class";
export const CLASS_LISTQ = "franchise-site-class/class-by-site";
export const CLASS_ADD = "franchise-site-class/site-class";
export const ADD_CONTAINER = "franchise-container/franchise-container-save";
export const UPDATE_CONTAINER =
  "franchise-container/franchise-container-update";
export const DELETE_SITE = "franchise-site/delete/site";
export const DELETE_CLASS = "franchise-site-class/delete/site-class";
export const DELETE_CONTAINER = "franchise-container/delete/container";
export const STAIR_STEP = "franchise-plans-tier-pricing";
export const DISABLE_PRICE = "disable-price-increase-for-franchise";

export const LOCK_LIST = "lockvue/locks";
export const LOCK_ADD = "lockvue/locks";
export const AVAILABLE_LOCK_LIST = "lockvue/locks/available";
export const LOCK_MAPPING = "lockvue/locks/mappings";
export const SITE_LOCK_MAPPING = "lockvue/locks/site-mappings";
export const LOCK_TIMELINE = "lockvue/locks/";

export function disablePriceApi(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + DISABLE_PRICE, data);
}
export function deleteContainer(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + DELETE_CONTAINER, data);
}
export function deleteSite(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + DELETE_SITE, data);
}
export function deleteClass(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + DELETE_CLASS, data);
}
//franchise list api
export function findFranchise(queryParams) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + FRANCHISES_URL_LIVE}?page=${
      queryParams.pageNumber
    }&per_page=${queryParams.pageSize}&sort_by=${
      queryParams.sortField
    }&sort_dir=${queryParams.sortOrder}&search_keyword=${
      queryParams.filter.search
    }`
  );
}

//franchise detail api
export function findFranchiseDetail(queryParams) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + FRANCHISES_URL_LIVE}/${queryParams}`
  );
}

//franchise based postcode api
export function findFranchisePostCode(queryParams, text) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + POSTCODE_LIVE}?postcode=${
      text ? text : ""
    }&franchise_id=${queryParams}`
  );
}

//franchise sector postcode api
export function findFranchiseSectorPostCode(queryParams, text) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + SECTOR}?franchise_id=${queryParams}`
  );
}

//franchise postcode api
export function createFranchisePostCode(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + POSTCODE, data);
}

//franchise delete postcode api
export function deleteFranchisePostCode(id) {
  return axios.delete(import.meta.env.REACT_APP_SITE_URL + POSTCODE + `/${id}`);
}
//delete franchise sector api
export function deleteFranchiseSector(id) {
  return axios.delete(import.meta.env.REACT_APP_SITE_URL + SECTOR + `/${id}`);
}
//franchise sector postcode api
export function createFranchiseSectorPostCode(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + SECTOR, data);
}
//franchise sector postcode api
export function editFranchiseSectorPostCode(query, data) {
  return axios.post(
    import.meta.env.REACT_APP_SITE_URL + SECTOR + `/${query}`,
    data
  );
}
//franhcise van list api
export function findFranchiseVan(queryParams) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + VAN_LIVE}?franchise_id=${queryParams}`
  );
}
//create franchise van api
export function createFranchiseVan(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + VAN_LIVE, data);
}
//edit van on franchise detail page
export function franchiseEditVan(data, id) {
  return axios.post(
    import.meta.env.REACT_APP_SITE_URL + VAN_LIVE + `/${id}?_method=PATCH`,
    data
  );
}
export function createFranchiseDepotOnSearch(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + DEPOT_SEARCH_SAVE, data);
}
export function createFranchiseVanStatus(data) {
  // mock.restore();

  return axios.post(import.meta.env.REACT_APP_SITE_URL + VAN_STATUS, data);
}
export function franchiseSectorStatus(data) {
  // mock.restore();

  return axios.post(import.meta.env.REACT_APP_SITE_URL + SECTOR_STATUS, data);
}

export function createFranchiseDriverLoaderStatus(data) {
  // mock.restore();

  return axios.post(import.meta.env.REACT_APP_SITE_URL + DRIVERLOADER_STATUS, data);
}
export function createFranchiseDepotStatus(data) {
  // mock.restore();

  return axios.post(import.meta.env.REACT_APP_SITE_URL + DEPOT_STATUS, data);
}
export function findFranchiseDepot(queryParams) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + DEPOT_LIST}?franchise_id=${
      queryParams?.franchise_id ? queryParams?.franchise_id : queryParams || ""
    }&customer_postcode=${queryParams?.postcode}&without_franchise=${queryParams?.drop_off }`
  );
}
export function findFranchiseDriverLoader(queryParams) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL +
      DRIVER_LOADER}?franchise_id=${queryParams}`
  );
}
export function addFranchiseDriverLoader(data) {
  return axios.post(`${import.meta.env.REACT_APP_SITE_URL + DRIVER_LOADER}`, data);
}
export function findFranchiseDepotSearch(queryParams) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + DEPOT_SEARCH}?name=${queryParams}`
  );
}
export function findFranchiseDriverSearch(ids) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + DRIVER_SEARCH_LIST}?franchise_id=${ids}`
  );
}

export function createFranchise(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + FRANCHISES_URL_LIVE, data);
}
export function editFranchisePopDetail(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + FRANCHISES_POPOVER, data);
}
export function editFranchise(data, id) {
  return axios.post(
    import.meta.env.REACT_APP_SITE_URL +
      FRANCHISES_URL_LIVE +
      `/${id}?_method=PATCH`,
    data
  );
}

export function findFranchiseCountry(text, promotion) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + COUNTRY_FRANCHISE}?country_id=${text}${
      promotion === "promotion" ? `&promotion=${1}` : ""
    }`
  );
}

//delete franchise
export function deleteFranchise(ids) {
  return axios.post(`${import.meta.env.REACT_APP_SITE_URL + DELETE}`, ids);
}

//working days
export function findWorkingDays(id) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + WORKING_DAYS}?franchise_id=${id}`
  );
}
export function editWorkingDays(value) {
  return axios.post(
    `${import.meta.env.REACT_APP_SITE_URL + EDIT_WORKING_DAYS}`,
    value
  );
}

export function automatePrice(value) {
  return axios.post(`${import.meta.env.REACT_APP_SITE_URL + Auto_Mate}`, value);
}

export function getTimeline(id) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL +
      "franchises-timeline"}?franchise_id=${id}`
  );
}

export function createSite(data, edit) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + CREATE_SITE + edit, data);
}

/**
 * Fetches written instructions and media slot URLs for a franchise site.
 *
 * @param {string|number} siteId - Franchise site identifier.
 * @returns {Promise<import("axios").AxiosResponse>} Axios response.
 */
export function getSiteInstructions(siteId) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL}${CREATE_SITE}/${siteId}/instructions`
  );
}

/**
 * Saves written site instructions for a floor (independent of site form save).
 *
 * @param {string|number} siteId - Franchise site identifier.
 * @param {string} instructions - Plain-text instructions body.
 * @param {string} [what3words] - what3words location hint for this floor.
 * @param {"G"|"1F"} [floor="G"] - Instruction floor.
 * @returns {Promise<import("axios").AxiosResponse>} Axios response.
 */
export function saveSiteInstructionsText(
  siteId,
  instructions,
  what3words,
  floor = "G"
) {
  const formData = new FormData();
  formData.append("instructions", instructions ?? "");
  formData.append("what3words", what3words ?? "");
  formData.append("floor", floor);
  return axios.post(
    `${import.meta.env.REACT_APP_SITE_URL}${CREATE_SITE}/${siteId}/instructions`,
    formData
  );
}

/**
 * Uploads a PDF, image, or video into a fixed instruction slot for a site floor.
 *
 * @param {string|number} siteId - Franchise site identifier.
 * @param {string} slot - One of pdf, image_1 through image_5, video_1, video_2.
 * @param {File} file - File to upload.
 * @param {"G"|"1F"} [floor="G"] - Instruction floor.
 * @returns {Promise<import("axios").AxiosResponse>} Axios response.
 */
export function uploadSiteInstructionMedia(siteId, slot, file, floor = "G") {
  const formData = new FormData();
  formData.append("slot", slot);
  formData.append("file", file);
  formData.append("floor", floor);
  return axios.post(
    `${import.meta.env.REACT_APP_SITE_URL}${CREATE_SITE}/${siteId}/instructions/upload`,
    formData
  );
}

/**
 * Removes the media file from an instruction slot.
 * Sends `slot` as a query parameter because multipart/urlencoded DELETE bodies
 * are often not parsed by PHP/Laravel the same way as POST.
 *
 * @param {string|number} siteId - Franchise site identifier.
 * @param {string} slot - One of pdf, image_1 through image_5, video_1, video_2.
 * @param {"G"|"1F"} [floor="G"] - Instruction floor.
 * @returns {Promise<import("axios").AxiosResponse>} Axios response.
 */
export function deleteSiteInstructionMedia(siteId, slot, floor = "G") {
  const q = encodeURIComponent(String(slot));
  const f = encodeURIComponent(String(floor));
  return axios.delete(
    `${import.meta.env.REACT_APP_SITE_URL}${CREATE_SITE}/${siteId}/instructions/upload?slot=${q}&floor=${f}`
  );
}

export function getSiteList(franchiseId, productId) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL +
      SITE_LIST}?franchise_id=${franchiseId}&product_id=${productId}`
  );
}

export function getClassList(queryParams) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + CLASS_LIST}?franchise_id=${queryParams}`
  );
}
export function getClassSiteList(queryParams) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + CLASS_LISTQ}?site_id=${queryParams}`
  );
}

export function createClass(data, edit, id) {
  return axios.post(
    import.meta.env.REACT_APP_SITE_URL +
      CLASS_ADD +
      (edit === "edit" ? `/${id}?_method=PATCH` : ""),
    data
  );
}

export function createContainerFranchise(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + ADD_CONTAINER, data);
}
export function updateContainerFranchise(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + UPDATE_CONTAINER, data);
}

export function setStairStepPrice(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + STAIR_STEP, data);
}

//create Application Fee
export function createApplicationFee(data) {
  return axios.post(
    import.meta.env.REACT_APP_SITE_URL + "franchise-application-fee",
    data
  );
}

/**
 * Fetch a franchise's change log.
 *
 * @param {Object} queryParams Paging and filters for the log endpoint
 * @param {number|string} f_id Franchise id
 * @returns {Promise}
 */
export function fetchLogsOfFranchise(queryParams, f_id) {
  return axios.get(
    import.meta.env.REACT_APP_SITE_URL +
      "quickbooks/stripe-sync-logs/listing" +
      `?page=${queryParams.pageNumber}&per_page=${queryParams.pageSize}&sort_by=${queryParams.sortField}&sort_dir=${queryParams.sortOrder}&search_keyword=${queryParams.filter.search}&franchise_id=${f_id}`
  );
}

//lock apis
/**
 * Fetch a page of a franchise's locks, filtered and optionally sorted.
 *
 * @param {Object} queryParams pageNumber, pageSize, franchise_id, filter, and
 *   optional sort_by / sort_dir (omitted = the server's default, newest first)
 * @returns {Promise}
 */
export function getLockList(queryParams) {
  const { pageNumber, pageSize, franchise_id, filter, sort_by, sort_dir } = queryParams;

  let url = `${import.meta.env.REACT_APP_SITE_URL +
    LOCK_LIST}?franchise_id=${franchise_id}`;

  // Add pagination parameters
  if (pageNumber) url += `&page=${pageNumber}`;
  if (pageSize) url += `&per_page=${pageSize}`;

  // Add filter parameters
  if (filter) {
    if (filter.display_name) url += `&display_name=${filter.display_name}`;
    if (filter.lock_type) url += `&lock_type=${filter.lock_type}`;
    if (filter.subtype) url += `&subtype=${filter.subtype}`;
    if (filter.serial_number) url += `&serial_number=${filter.serial_number}`;
  }

  if (sort_by) url += `&sort_by=${encodeURIComponent(sort_by)}&sort_dir=${sort_dir === "desc" ? "desc" : "asc"}`;

  return axios.get(url);
}
export function getLockSiteList(queryParams) {
  return axios.get(
    `${import.meta.env.REACT_APP_SITE_URL + LOCK_LIST}?site_id=${queryParams}`
  );
}

export function createLock(data, edit, id) {
  return axios.post(
    import.meta.env.REACT_APP_SITE_URL +
      LOCK_ADD +
      (edit === "edit" ? `/${id}?_method=PATCH` : ""),
    data
  );
}

/**
 * Lists locks available for franchise/site.
 *
 * @param {{ franchise_id: string|number, site_id?: string|number }} data - Query params.
 * @returns {Promise<import("axios").AxiosResponse>} Axios response.
 */
export function getAvailableLockList(data) {
  let url =
    import.meta.env.REACT_APP_SITE_URL +
    AVAILABLE_LOCK_LIST +
    `?franchise_id=${data.franchise_id}`;
  if (data.site_id) {
    url += `&site_id=${data.site_id}`;
  }
  return axios.get(url);
}

export function mapLockToContainer(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + LOCK_MAPPING, data);
}

export function removeLockMapping(data) {
  return axios.delete(import.meta.env.REACT_APP_SITE_URL + LOCK_MAPPING, { data });
}

/**
 * POST site ↔ lock mapping (`gate_number`: `gate_1` | `gate_2`).
 *
 * @param {{ lock_id: string|number, site_id: string|number, gate_number?: string }} data - Mapping payload; include `gate_number` for multi-gate sites.
 * @returns {Promise<import("axios").AxiosResponse>} Axios response.
 */
export function mapLockToSite(data) {
  return axios.post(import.meta.env.REACT_APP_SITE_URL + SITE_LOCK_MAPPING, data);
}

/**
 * DELETE site lock mapping; send `gate_number` when removing a specific gate slot.
 *
 * @param {{ lock_id: string|number, site_id: string|number, gate_number?: string }} data - Body for DELETE.
 * @returns {Promise<import("axios").AxiosResponse>} Axios response.
 */
export function removeLockSiteMapping(data) {
  return axios.delete(import.meta.env.REACT_APP_SITE_URL + SITE_LOCK_MAPPING, { data });
}

export function getLockTimeline(id) {
  return axios.get(
    import.meta.env.REACT_APP_SITE_URL + LOCK_TIMELINE + `${id}/activities`
  );
}
